<template>
  <section class="about p-relative" id="about">
    <div class="divider">
      <svgDivider fillColor="#41354d"/>
    </div>
    <div class="container grid-xl p-relative">
      <div class="columns">
        <div class="column col-lg-12 col-xl-6 col-6">
          <h1 class="about__heading">ABOUT</h1>
          <p>
            A pellentesque sit amet porttitor eget dolor morbi non. Pellentesque id nibh tortor id aliquet lectus. Ultrices neque ornare aenean euismod elementum nisi quis eleifend quam. Purus faucibus ornare suspendisse sed nisi lacus sed. Pretium vulputate sapien nec sagittis. Vitae congue mauris rhoncus aenean. Nisi lacus sed viverra tellus in hac habitasse platea dictumst. Leo integer malesuada nunc vel risus. Nisl vel pretium lectus quam id leo in vitae. Urna id volutpat lacus laoreet non curabitur gravida arcu ac. Orci ac auctor augue mauris augue. Eget mauris pharetra et ultrices neque ornare. Quam vulputate dignissim suspendisse in est ante in nibh mauris. Elit duis tristique sollicitudin nibh sit.
          </p>
        </div>
        <div class="column col-lg-12 col-xl-6 col-6 img_fl">
          <div class="about__img_cnt">
            <div class="img_inner">
              <img :src="require('../assets/images/laptop.png')" alt="About image" class="img_inner__img">
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column col-lg-12 col-xl-6 col-6 a_col_1">
          <h2>Vitae aliquet</h2>
          <p>
            Vitae aliquet nec ullamcorper sit. Diam volutpat commodo sed egestas egestas. Malesuada bibendum arcu vitae elementum curabitur. Et egestas quis ipsum suspendisse ultrices gravida dictum fusce
          </p>
          <p>
            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
          </p>
        </div>
        <div class="column col-lg-12 col-xl-6 col-6 a_col_2">
          <h3>Fringilla est</h3>
          <p>
            Diam ut venenatis tellus in. Fringilla est ullamcorper eget nulla facilisi etiam dignissim. Adipiscing elit duis tristique sollicitudin nibh sit amet. 
          </p>
          <h4>
            Lacus laoreet
          </h4>
          <p>
            Lacus laoreet non curabitur gravida arcu ac. Nisl purus in mollis nunc sed id semper risus in. Commodo nulla facilisi nullam vehicula ipsum a. Facilisis leo vel fringilla est ullamcorper eget.
          </p>
        </div>
      </div>
      <topButton :backColor="true"/>
    </div>
  </section>
</template>

<script>
import topButton from './topButton'
import svgDivider from './svg_icons/svgDivider';
export default {
  name: 'SecondSection',
  components: {
    topButton,
    svgDivider
  }
}
</script>

<style scoped lang="scss">
.about{
  .columns:last-of-type{
    padding-top: 3rem;
  }
  &__heading{
    text-align: center;
  }
  .img_fl{
    display: flex;
    align-items: center;
  }
  &__img_cnt{
    padding-top: 3rem;
    flex: 1 2 620px;
    .img_inner{
      position: relative;
      height: 0;
      padding-bottom: 58.38709677419355%;
      &__img{
        position: absolute;
      }
    }
  }
}
.go_top_btn{
  position: absolute;
  right: 1rem;
  bottom: -75px;
}
@media screen and (min-width: 961px){
  .about__img_cnt{
    padding-top: 0;
  }
  .a_col_1{
    padding-right: 1rem;
  }
  .a_col_2{
    padding-left: 1rem;
  }
}
</style>
